enum FilterOptions {
    ID = 'Search by Contract ID',
    INITIAL_DATE = 'Search by Initial Date',
    ACTIVATION_DATE = 'Search by Activation Date',
}
export default FilterOptions;